import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=7c84dcff&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=7c84dcff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c84dcff",
  null
  
)

export default component.exports